export default "__VITE_ASSET__PXR8T8gK__"